<template>
  <div :class="'search-' + searchType">
    <view-toggle @change-view="getView" />
    <div
      class="search-view"
      :class="viewType + '-view'"
    >
      <sidebar />
      <results :view-type="viewType" />
    </div>
  </div>
</template>

<script>
/* Components */
import Results from './Results.vue';
import Sidebar from './Sidebar.vue';
import ViewToggle from './ViewToggle.vue';

export default {
  name: 'PostsSearch',
  components: {
    Results,
    Sidebar,
    ViewToggle,
  },
  inject: {
    searchType: {
      default: 'global',
    },
  },
  data() {
    return {
      viewType: 'grid',
    };
  },
  methods: {
    getView(type) {
      this.viewType = type;
    },
  }
};
</script>
